import { Link } from "react-router-dom";
import Footer from "@/pages/home/components/Footer";

export default function ThankYou() {
  return (
    <div className="min-w-0 bg-background-50 text-foreground-950 font-body">
      <header className="bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-10 h-14 md:h-20 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-1.5 md:gap-2 cursor-pointer"
          >
            <span className="w-7 h-7 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-sm md:text-lg">
              日
            </span>
            <span className="font-heading text-sm md:text-xl font-bold text-foreground-950 whitespace-nowrap">
              실전 일본어 연구소
            </span>
          </Link>
        </div>
      </header>

      <main>
        {/* Hero confirmation section */}
        <section className="relative py-10 md:py-28 px-4 md:px-10">
          <div className="absolute inset-0 bg-gradient-to-b from-primary-50/60 to-background-50"></div>
          <div className="relative max-w-4xl mx-auto text-center">
            <div className="w-14 h-14 md:w-20 md:h-20 mx-auto flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-check-line text-xl md:text-3xl text-primary-600"></i>
            </div>
            <h1 className="mt-5 md:mt-6 font-heading text-xl md:text-4xl font-bold text-foreground-950">
              신청서가 접수되었어요!
            </h1>
            <p className="mt-3 md:mt-4 text-sm md:text-lg text-foreground-700 leading-relaxed">
              작성해 주신 연락처로 <strong>24시간 이내</strong>에 안내 메시지를 보내드릴게요.
              <br className="hidden sm:block" />
              아래 절차에 따라 수강 등록을 진행해 주세요 :)
            </p>
          </div>
        </section>

        {/* Main content */}
        <section className="max-w-4xl mx-auto px-4 md:px-10 pb-12 md:pb-20 space-y-6 md:space-y-10">
          {/* Notice */}
          <div className="rounded-xl bg-accent-50 border border-accent-200 p-4 md:p-5">
            <p className="text-xs md:text-base text-accent-800 leading-relaxed">
              ※ 신청서 제출만으로는 수강이 확정되지 않습니다. 수강료 입금 후 &lsquo;수강 확정 안내&rsquo;를 받아야 최종 등록됩니다.
            </p>
          </div>

          {/* Next steps */}
          <div>
            <h2 className="font-heading text-base md:text-xl font-bold text-foreground-950 mb-4 md:mb-6">
              앞으로의 진행
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              <div className="flex gap-3 md:gap-4">
                <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading text-xs md:text-sm font-bold">
                  1
                </div>
                <div>
                  <h4 className="font-heading font-bold text-foreground-950 text-xs md:text-base">
                    개별 안내 메시지 수신
                  </h4>
                  <p className="mt-1 md:mt-1.5 text-xs md:text-sm text-foreground-700 leading-relaxed">
                    신청서에 기재해 주신 연락처로 수업 세부 사항, 결제 방법, 계좌번호를 안내드립니다.
                  </p>
                </div>
              </div>

              <div className="flex gap-3 md:gap-4">
                <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading text-xs md:text-sm font-bold">
                  2
                </div>
                <div>
                  <h4 className="font-heading font-bold text-foreground-950 text-xs md:text-base">
                    입금
                  </h4>
                  <p className="mt-1 md:mt-1.5 text-xs md:text-sm text-foreground-700 leading-relaxed">
                    안내받은 계좌로 수강료를 입금해 주세요. 입금 확인 후 수강 확정 절차가 진행됩니다.
                  </p>
                </div>
              </div>

              <div className="flex gap-3 md:gap-4">
                <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading text-xs md:text-sm font-bold">
                  3
                </div>
                <div>
                  <h4 className="font-heading font-bold text-foreground-950 text-xs md:text-base">
                    수강 확정
                  </h4>
                  <p className="mt-1 md:mt-1.5 text-xs md:text-sm text-foreground-700 leading-relaxed">
                    입금이 확인되면 <strong>확정 문자</strong>를 보내드립니다. 오픈채팅방 링크가 함께 발송되니, 입장 후 반별 공지사항을 확인해 주세요.
                  </p>
                </div>
              </div>

              <div className="flex gap-3 md:gap-4">
                <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading text-xs md:text-sm font-bold">
                  4
                </div>
                <div>
                  <h4 className="font-heading font-bold text-foreground-950 text-xs md:text-base">
                    개강 &mdash; 8주 여정 시작!
                  </h4>
                  <p className="mt-1 md:mt-1.5 text-xs md:text-sm text-foreground-700 leading-relaxed">
                    정해진 요일과 시간에 Zoom으로 만나요. 첫 주는 오리엔테이션 + 히라가나부터 가볍게 시작합니다.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick info card */}
          <div className="rounded-xl bg-secondary-50 border border-secondary-200 p-4 md:p-6">
            <h3 className="font-heading font-bold text-foreground-950 text-xs md:text-base mb-3 md:mb-5">
              수업 요약
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 text-xs md:text-sm">
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-calendar-line text-secondary-600"></i>
                <span>8주 완성 (주 2회)</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-time-line text-secondary-600"></i>
                <span>회당 75분</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-group-line text-secondary-600"></i>
                <span>최대 5명 소수정예</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-computer-line text-secondary-600"></i>
                <span>Zoom 라이브 수업</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-price-tag-3-line text-secondary-600"></i>
                <span>월 120,000원</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-700">
                <i className="ri-file-text-line text-secondary-600"></i>
                <span>교재 별도 구매</span>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center pt-2 md:pt-4">
            <p className="text-xs md:text-sm text-foreground-600 mb-3 md:mb-4">
              문의사항이 있으시면 언제든지 연락 주세요.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-3">
              <a
                href="mailto:siljeon.jp@gmail.com"
                className="inline-flex items-center gap-1.5 md:gap-2 px-4 md:px-5 py-2 md:py-2.5 rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 text-xs md:text-sm font-medium cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line"></i> siljeon.jp@gmail.com
              </a>
              <a
                href="http://pf.kakao.com/_VxdxgxnX"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 md:gap-2 px-4 md:px-5 py-2 md:py-2.5 rounded-md border border-accent-300 bg-accent-50 text-accent-700 hover:bg-accent-100 text-xs md:text-sm font-medium cursor-pointer whitespace-nowrap"
              >
                <i className="ri-kakao-talk-fill"></i> 카카오채널 문의하기
              </a>
              <Link
                to="/"
                className="inline-flex items-center gap-1.5 md:gap-2 px-5 md:px-6 py-2 md:py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-xs md:text-sm font-semibold cursor-pointer whitespace-nowrap"
              >
                홈으로 돌아가기
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}